import { Text } from '@mantine/core'
import { formatDriverName } from './formatDriverName'

interface DriverNameDisplayProps {
  driverName: string | null
  isMobile: boolean
}

export function DriverNameDisplay({ driverName, isMobile }: DriverNameDisplayProps) {
  // Vertical display with surname + first name initial
  const verticalText = formatDriverName(driverName)

  return (
    <Text
      size="sm"
      fw={600}
      c={driverName ? 'dark' : 'gray'}
      style={{
        fontSize: isMobile ? '10px' : '12px',
        lineHeight: 1.1,
        writingMode: 'vertical-rl',
        transform: 'rotate(180deg)',
        transformOrigin: 'center',
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        maxHeight: '100%',
      }}
    >
      {verticalText}
    </Text>
  )
}
